import React, { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, AuthContextValue } from "../providers/AuthProvider";
import Layout from "../pages/Layout";
import GuestLayout from "./GuestLayout";

type BaseLayoutProps = {
  children: ReactNode;
};

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { user } = useAuth() as AuthContextValue;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // setTimeout(() => {
    if (user && user.roleName && location.pathname === "/") {
      if (user.isFirstLogin && user.isFirstLogin === 1) {
        navigate("/changePassword?isFirstLogin=1");
      } else if (user.roleName === "ROLE_KFT_SUPER_ADMIN") {
        navigate("/admin");
      } else if (user.roleName === "ROLE_OFF_TAKER_ADMIN") {
        navigate("/off-taker");
      } else if (user.roleName === "BANK_ADMIN") {
        navigate("/bank");
      } else if (user.roleName === "INSURANCE_ADMIN") {
        navigate("/insurance");
      } else if (user.roleName === "ROLE_MPC_ADMIN") {
        navigate("/ad-dashboard");
      } else if (user.roleName === "ROLE_MPC_OPERATION") {
        navigate("/ad-dashboard");
      } else if (user.roleName === "ROLE_SUPER_ADMIN") {
        navigate("/sp-admin");
      } else if (user.roleName === "ROLE_KFT_SP_ADMIN") {
        navigate("/admin");
      } else if (
        user.roleName === "ROLE_MFI_ADMIN" ||
        user.roleName === "ROLE_MFI_OPERATION"
      ) {
        navigate("/mfi");
      }
    } else {
    }
    // }, 1);
  }, [user]);

  if (user && user.roleName) {
    return <Layout>{children}</Layout>;
  } else {
    return <GuestLayout>{children}</GuestLayout>;
  }
};

export default BaseLayout;
